export const defaultHair = 0;
export const defaultEyewear = 0;
export const defaultOutfit = 0;
